import { render, staticRenderFns } from "./NegociacaoPagSeguro.vue?vue&type=template&id=13356040&"
import script from "./NegociacaoPagSeguro.vue?vue&type=script&lang=js&"
export * from "./NegociacaoPagSeguro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports